import { ReactNode } from "react"
import { Sidebar } from "../Sidebar"
import { PageTitle } from "../PagetTitle"
import { HeaderGen } from "./../HeaderGen"
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

interface Props {
    pageTitle: string
    children: ReactNode
    onSearchGen?: any
    onExportFile?: any
}

export const DashboardLayout = ({ children, pageTitle, onSearchGen, onExportFile }: Props) => {
    const state = useSelector((state: any) => state.business)
    const location = useLocation()
    return (
        <div className={`grid grid-cols-layout grid-cols-layout-md h-screen`}>
            <Sidebar />
            <div id="content-pages" className="ml-[24px] mr-[24px]">
                <HeaderGen onSearchGen={onSearchGen} />
                <div className="flex w-full justify-between items-center">
                    <div>
                        <PageTitle pageName={pageTitle} />
                    </div>
                    {
                        ['OUT', 'IN'].includes(state.typeBusiness)
                        && ['/withdrawal', '/compliance'].includes(location.pathname)
                        && (
                            <>
                                <div className={`text-end`}>
                                    <button className='btn-downl profile-active fontPageTitle600' onClick={onExportFile}>
                                        <div className='flex text-[16px]'>
                                            <div className='mr-2'>
                                                <ArrowDownTrayIcon className='w-[1.5rem] icon-blue cursor-pointer' />
                                            </div>
                                            <div className="text-[#005FF9] ">Export all (.csv)</div>
                                        </div>
                                    </button>
                                </div>
                            </>
                        )
                    }
                </div>
                {children}
            </div>
        </div>
    )
}